import privacyPolicy from "assets/files/adatkezelesi_tajekoztato.pdf";
import cookiePolicy from "assets/files/suti_tajekoztato.pdf";

const settings = {
  //logok engedélyezése/letiltása
  debug: false,

  onDevServer: false,

  //document.title FIX előtagja
  pageTitlePostfix: " - Csángó 10",

  //Alapértelmezett ALT cimke
  imageAlt: "Csángó 10 lakások",

  //Minden kép altja elé bekerül ez a szöveg
  imageAltPostfix: [
    "13 kerület új építésű lakások - ",
    "Új építésű lakások budapest - ",
    "Eladó lakás budapest - ",
    "Eladó budapesti lakások - ",
  ],

  router: {
    //Az animáció időtartama oldalváltáskor (s)
    animationDurationOnRouteChange: 0.3,
  },

  //Backend hívások
  req: {
    baseUrl: "https://csango10.hu/",

    //Összes lakás
    allProperties: "properties/list.php",

    //Kiemelt lakások
    featuredProperties: "properties/featured.php",

    //Adott lakás részletei
    propertySingle: "properties/details.php",

    login: "login.php",

    token: "token.php",

    logout: "logout.php",

    //Lakás árának és státuszának módosítása
    propertyEdit: "properties/edit.php",

    //Globális módosítások
    globalEdit: "properties/global-edit.php",

    //Kapcsolat
    contact: "contact.php",

    //Galéria (GET)
    gallery: "gallery.php",

    blog: {
      get_entries: "blog/scripts/get-entries.php",
    },
  },

  css: {
    primary: "#766a60",
    secondary: "#257873",
  },

  captcha: {
    siteKey: "6LeTSs4cAAAAAMX8yLUSs-TDBrwgIVCz7aMdvB-o",
  },

  google_analytics: {
    id: "G-KRWZ5VZ38Z",
  },

  contact: {
    phone: "+36 20 366 3660",
    email: "info@csango10.hu",
    show_room: "CSNG-UTCA-1012 KFT. 1133 Budapest, Ipoly u. 3.",
    construction: "1134 Budapest, Csángó u. 10-12.",
    company: (
      <>
        CSNG-UTCA-1012 KFT.
        <br />
        Asz.:26365615-2-41
        <br />
        1016 Budapest, Lisznyai utca 15. III. emelet 12.
      </>
    ),

    facebook: "#fb",
    instagram: "#insta",
  },

  files: {
    privacyPolicy: privacyPolicy, //Adatkezelési tájékoztató
    cookiePolicy: cookiePolicy, //Süti tájékoztató
  },
};

export default settings;
